import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import { Typography, CircularProgress, Paper, Tabs, Tab, Box, Button } from '@mui/material';
import PageHeader from '../../components/PageHeader/PageHeader';

const SERVER_URL_NEW = "https://crossovergames-8b4eb8e6663f.herokuapp.com";

const SportTabs = ({ gameType, sports, constructLink }) => {
    const [selectedSportIndex, setSelectedSportIndex] = useState(0);

    const handleChange = (event, newValue) => {
        setSelectedSportIndex(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={selectedSportIndex} onChange={handleChange} aria-label="sport tabs" variant="scrollable" scrollButtons="auto">
                    {sports.map(sport => <Tab label={sport.sportName} key={sport.sportId} />)}
                </Tabs>
            </Box>
            {sports.map((sport, index) => (
                <div role="tabpanel" hidden={selectedSportIndex !== index} key={sport.sportId}>
                    {selectedSportIndex === index && (
                        <Box sx={{ p: 3 }}>
                            {sport.gamesByMonth.map(monthData => (
                                <div key={monthData.month} style={{ marginBottom: '20px' }}>
                                    <Typography variant="h6">{monthData.month}</Typography>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
                                        {monthData.games.map(game => (
                                            <Button
                                                key={game.date}
                                                component={Link}
                                                to={constructLink(gameType, sport.sportName, game.date)}
                                                variant="outlined"
                                            >
                                                {game.displayName}
                                            </Button>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </Box>
                    )}
                </div>
            ))}
        </Box>
    );
};

const ArchiveBrowser = () => {
    const [archiveData, setArchiveData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchArchiveData = async () => {
            try {
                setLoading(true);
                const response = await Axios.get(`${SERVER_URL_NEW}/api/archive/public/summary`);
                setArchiveData(response.data);
                setError(null);
            } catch (err) {
                setError('Failed to fetch archive data. Please try again later.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchArchiveData();
    }, []);

    const constructLink = (gameType, sportName, date) => {
        return `/${gameType}/${sportName.toLowerCase()}/${date}`;
    };

    if (loading) {
        return <div style={{display: 'flex', justifyContent: 'center', marginTop: '50px'}}><CircularProgress /></div>;
    }

    if (error) {
        return <Typography color="error" align="center" style={{margin: '20px'}}>{error}</Typography>;
    }

    return (
        <Paper style={{ padding: '20px', margin: '20px', background: 'transparent' }} elevation={0}>
            {!archiveData && !loading && !error && <Typography align="center">No archive data available.</Typography>}
            {archiveData && Object.keys(archiveData).map(gameType => (
                <div key={gameType} style={{ marginBottom: '30px' }}>
                    <Typography variant="h5" gutterBottom style={{textTransform: 'capitalize'}}>{archiveData[gameType].displayName}</Typography>
                    <Paper>
                        <SportTabs gameType={gameType} sports={archiveData[gameType].sports} constructLink={constructLink} />
                    </Paper>
                </div>
            ))}
        </Paper>
    );
};

const ArchivePage = () => {
    return (
        <div>
            <PageHeader title="Game Archive" />
            <ArchiveBrowser />
        </div>
    );
};

export default ArchivePage; 